module.exports = __webpack_public_path__ + "static/media/GenericReticle.639577a0.png";